import { shadows } from "./foundations/shadows";

/**
 * For custom components, you can apply the focus ring styling either as:
 *
 * _focus - if you want the ring regardless of how focus was achieved
 * e.g. for input fields.
 *
 * _focusVisible - if you only want the ring due to keyboard navigation and not
 * from mouse interaction.
 */
export const focusRing = {
  outline: "none", // remove the default focus ring
  boxShadow: shadows.outline,
};

/**
 * Styling an error/ invalid state on an input which is focussed
 */
export const focusRingInvalid = {
  outline: "none",
  boxShadow: shadows.invalid,
};
